import EmailRulesService from './EmailRulesService'

let instance

export default function EmailRulesServiceProvider () {
  if (!instance) {
    instance = new EmailRulesService()
  }

  return instance
}



// WEBPACK FOOTER //
// ./src/api/email-rules/EmailRulesServiceProvider.js